import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../../../../types/super-cut-field'
import CaptionStyleField from '../../../../../form-fields/super-cut/caption-style'
import { CreationCaptureInfoContext } from '../manager'
import SuperCutSegmentationType from '../../../../../../types/super-cut-segmentation-type'

const CaptionStyle = styled(CaptionStyleField)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureInfoCaptionStyleField = ({ field }: Props) => {
    const { segmentationType } = useContext(CreationCaptureInfoContext)

    return (
        <>
            {segmentationType === SuperCutSegmentationType.Caption && (
                <CaptionStyle
                    {...{
                        field,
                    }}
                />
            )}
        </>
    )
}

export default CreationCaptureInfoCaptionStyleField
